import React from "react";
import { Chip, Tooltip } from "@mui/material";
import { useWebSocket } from "../contexts/WebSocketContext";

const CHIP_CONFIG = {
  connected: {
    color: "success",
    label: "Online",
    variant: "filled",
  },
  disconnected: {
    color: "default",
    label: "Offline",
    variant: "outlined",
  },
  error: {
    color: "error",
    label: "Socket Error",
    variant: "filled",
  },
  connecting: {
    color: "warning",
    label: "Connecting",
    variant: "outlined",
  },
};

const WebSocketStatusChip = ({ sx }) => {
  const { socketState, websocketUrl } = useWebSocket();
  const chip = CHIP_CONFIG[socketState] || CHIP_CONFIG.connecting;

  return (
    <Tooltip title={websocketUrl || "WebSocket URL unavailable"}>
      <Chip
        size="small"
        color={chip.color}
        label={chip.label}
        variant={chip.variant}
        sx={sx}
      />
    </Tooltip>
  );
};

export default WebSocketStatusChip;
